import React, { useEffect, useState } from 'react';

type AnjouangamingProps = {
  license: {
    id: string;
    windowPropertyName: string;
    site: string;
    email: string;
  };
  className?: string;
};

const isSSR = typeof window === 'undefined';
const ID = 'anjouangaming-lib';

export const Anjouangaming = ({
  license,
  className,
}: AnjouangamingProps) => {
  const host = `https://${license.id}.snippet.anjouangaming.org/anj-seal.js`;
  const [isInit, setIsInit] = useState(false);

  const init = () => {
    if (license) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window[license.windowPropertyName]?.init();
    }
  };

  const onLoadHandler = function () {
    try {
      if (!isInit) {
        init();
        setIsInit(true);
      }
    }
    catch (error) {
      console.error(error);
    }
  };

  const loadScript = async (host: string, id: string) => {
    if (document.getElementById(id)) {
      onLoadHandler();
    }

    const script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.id = id;
    script.src=host;
    // ADD
    script.onload = onLoadHandler;
    // ADD
    document.head.appendChild(script);
  };

  useEffect(() => {
    if (!host) {
      console.error(`Host for Anjouangaming script.src from rest.host=${host}`);
    }

    if (!isSSR && host) {
      loadScript(host, ID).catch((error) => console.error(error));
    }
  }, [host]);

  return (
    <div className={className}
         id={`anj-${license.id}`}
         data-anj-seal-id={license.id}
         data-anj-image-size="40"
         data-anj-image-type="basic-small" />
  );
};
